import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const Location = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="location-svg"
      width={width}
      height={height}
      fill={fill}
      stroke="none"
      className={className}
      viewBox="0 0 23 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4766 14.8164C9.76505 14.8164 8.37278 13.3862 8.37278 11.6261C8.37278 9.86716 9.76505 8.43535 11.4766 8.43535C13.1882 8.43535 14.5773 9.86716 14.5773 11.6261C14.5773 13.3862 13.1882 14.8164 11.4766 14.8164ZM11.4766 6.00108C8.42388 6.00108 5.9395 8.52537 5.9395 11.6261C5.9395 14.728 8.42388 17.2523 11.4766 17.2523C14.5294 17.2523 17.0138 14.728 17.0138 11.6261C17.0138 8.52537 14.5294 6.00108 11.4766 6.00108ZM19.2842 2.75983C17.2852 0.981598 14.5103 0 11.4766 0C8.43985 0 5.66807 0.981598 3.66908 2.75983C1.26774 4.90089 0 8.15318 0 12.168C0 20.9113 10.0588 31.1551 10.4867 31.5888C10.7518 31.8512 11.1062 32 11.4766 32C11.8471 32 12.2015 31.8512 12.4634 31.5888C12.8913 31.1551 22.9533 20.9113 22.9533 12.168C22.9533 8.15318 21.6856 4.90089 19.2842 2.75983Z"
      />
    </svg>
  );
};
/* eslint-enable max-len */

Location.defaultProps = {
  className: null,
};

Location.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default Location;
